import { getAsyncApiExampleContext as e } from "../helpers/get-asyncapi-example-context.js";
import { getGeneratedPayloadExample as t } from "../helpers/get-generated-payload-example.js";
import { getMessageExampleContent as n } from "../helpers/get-message-example-content.js";
import r from "./ExamplePicker.vue.js";
import { Fragment as i, computed as a, createBlock as o, createCommentVNode as s, createElementBlock as c, createElementVNode as l, createVNode as u, defineComponent as d, mergeModels as f, normalizeClass as p, openBlock as m, ref as h, renderList as g, toDisplayString as _, unref as v, useModel as y, watch as b, withCtx as x } from "vue";
import { ScalarCard as S, ScalarCardFooter as C, ScalarCardHeader as w, ScalarCardSection as T } from "@scalar/components/card";
import { ScalarCodeBlock as E } from "@scalar/components/code-block";
import { ScalarWrappingText as D } from "@scalar/components/wrapping-text";
import { getResolvedAsyncApiRef as O } from "@scalar/workspace-store/helpers/get-resolved-async-api-ref";
//#region src/code-example/components/AsyncApiCodeExample.vue?vue&type=script&setup=true&lang.ts
var k = { class: "text-c-2 font-code min-w-0 font-semibold break-words" }, A = {
	key: 0,
	class: "text-c-1 whitespace-nowrap"
}, j = { class: "flex w-full flex-col" }, M = {
	key: 0,
	class: "text-c-2 px-3 py-2 text-sm"
}, N = {
	key: 2,
	class: "text-c-2 p-4",
	role: "status"
}, P = { class: "flex min-w-0 flex-1 flex-wrap items-center gap-2" }, F = {
	key: 1,
	class: "text-c-2 min-w-0 truncate px-1.5 py-0.75 text-base"
}, I = { class: "ml-auto flex min-w-0 items-center" }, L = {
	key: 1,
	class: "text-c-2 min-w-0 truncate px-1.5 py-0.75 text-base"
}, R = /*@__PURE__*/ d({
	__name: "AsyncApiCodeExample",
	props: /*@__PURE__*/ f({
		document: {},
		operationName: {}
	}, {
		selectedMessage: { default: "" },
		selectedMessageModifiers: {}
	}),
	emits: ["update:selectedMessage"],
	setup(d) {
		let f = a(() => e(d.document, d.operationName)), R = a(() => (f.value?.channel?.address ?? d.operationName).split(/({[^}]+})/)), z = y(d, "selectedMessage"), B = h(""), V = a(() => Object.fromEntries((f.value?.messages ?? []).map(({ name: e, message: t }) => [e, { summary: t.title || t.name || e }]))), H = a(() => f.value?.messages.find(({ name: e }) => e === z.value)?.message), U = a(() => (H.value?.examples ?? []).flatMap((e, t) => {
			let n = O(e);
			return n?.payload === void 0 ? [] : [{
				key: String(t),
				...n
			}];
		})), W = a(() => Object.fromEntries(U.value.map((e, t) => [e.key, { summary: e.name || e.summary || `Example ${t + 1}` }]))), G = a(() => U.value.find(({ key: e }) => e === B.value)), K = a(() => `Message: ${V.value[z.value]?.summary ?? "Select a message"}`), q = a(() => `Message example: ${W.value[B.value]?.summary ?? "Select an example"}`);
		b(V, (e) => {
			Object.hasOwn(e, z.value) || (z.value = Object.keys(e)[0] ?? "");
		}, { immediate: !0 }), b([z, () => d.operationName], () => {
			B.value = Object.keys(W.value)[0] ?? "";
		}), b(W, (e) => {
			Object.hasOwn(e, B.value) || (B.value = Object.keys(e)[0] ?? "");
		}, { immediate: !0 });
		let J = a(() => n(G.value ? G.value.payload : H.value ? t(H.value) : void 0, H.value?.contentType ?? d.document.defaultContentType));
		return (e, t) => (m(), o(v(S), {
			class: "request-card dark-mode min-w-0",
			label: "Message example"
		}, {
			default: x(() => [
				u(v(w), { class: "flex-nowrap items-start gap-3 pr-2.5 [&_.scalar-card-header-title]:flex-1 [&_.scalar-card-header-title]:whitespace-normal [&>div:last-child]:shrink-0" }, {
					default: x(() => [
						t[2] ||= l("span", { class: "sr-only" }, "Message example for", -1),
						l("span", { class: p(["font-code mr-1.5 uppercase", f.value?.operation.action === "send" ? "text-blue" : "text-green"]) }, _(f.value?.operation.action), 3),
						l("span", k, [(m(!0), c(i, null, g(R.value, (e, t) => (m(), c(i, { key: t }, [e.startsWith("{") && e.endsWith("}") ? (m(), c("span", A, _(e), 1)) : (m(), o(v(D), {
							key: 1,
							text: e
						}, null, 8, ["text"]))], 64))), 128))])
					]),
					_: 1
				}),
				u(v(T), { class: "custom-scroll flex flex-1 p-0" }, {
					default: x(() => [l("div", j, [J.value?.structural ? (m(), c("p", M, " Structure only; not encoded ")) : s("", !0), J.value ? (m(), o(v(E), {
						key: 1,
						class: "bg-b-2 h-full",
						content: J.value.content,
						lang: J.value.lang,
						lineNumbers: ""
					}, null, 8, ["content", "lang"])) : (m(), c("p", N, " No message payload example available. "))])]),
					_: 1
				}),
				Object.keys(V.value).length || U.value.length ? (m(), o(v(C), {
					key: 0,
					class: "bg-b-3 relative flex shrink-0 flex-wrap items-center justify-end gap-2 p-1.5"
				}, {
					default: x(() => [l("div", P, [U.value.length > 1 ? (m(), o(r, {
						key: 0,
						modelValue: B.value,
						"onUpdate:modelValue": t[0] ||= (e) => B.value = e,
						"aria-label": q.value,
						examples: W.value
					}, null, 8, [
						"modelValue",
						"aria-label",
						"examples"
					])) : U.value.length === 1 ? (m(), c("span", F, _(W.value[B.value]?.summary), 1)) : s("", !0), l("div", I, [Object.keys(V.value).length > 1 ? (m(), o(r, {
						key: 0,
						modelValue: z.value,
						"onUpdate:modelValue": t[1] ||= (e) => z.value = e,
						"aria-label": K.value,
						examples: V.value
					}, null, 8, [
						"modelValue",
						"aria-label",
						"examples"
					])) : Object.keys(V.value).length === 1 ? (m(), c("span", L, _(V.value[z.value]?.summary), 1)) : s("", !0)])])]),
					_: 1
				})) : s("", !0)
			]),
			_: 1
		}));
	}
});
//#endregion
export { R as default };

//# sourceMappingURL=AsyncApiCodeExample.vue_vue_type_script_setup_true_lang.js.map